import { Component, OnInit } from "@angular/core";
import { ThingStatus } from "src/app/_models/thingStatus";
import { ThingAccessories } from "src/app/_models/thingAccessories";
import { ThingControl } from "src/app/_models/thingControl";
import { Subscription, Observable, observable } from "rxjs";
import { DataStore, MissionService, HTTPCallsService, AuthenticationService } from "src/app/_services";
import { ActivatedRoute, Router } from "@angular/router";

import { MatSliderChange } from "@angular/material";
import { timestamp, repeat } from "rxjs/operators";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { delay, timeout } from "q";
import { NgxIndexedDBService } from 'ngx-indexed-db';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA
} from "@angular/material/dialog";
import { MsaterControlComponent } from "src/app/dashboard/things/msater-control/msater-control.component"
import { AdminUser } from 'src/app/_models/adminuser';
import { AddNumberDialogComponent } from './thing-settings-edit/add-number-dialog/add-number-dialog.component';
import { element } from 'protractor';
export interface DialogData {
  status: string;
}
export interface DialogDataUser {
  phoneNumber: string
}

@Component({
  selector: "app-thing-settings",
  templateUrl: "./thing-settings.component.html",
  styleUrls: ["./thing-settings.component.css"]
})
export class ThingSettingsComponent implements OnInit {
  defaultImage: string
  adminPhoneNumber: string
  currentUser: AdminUser
  masterStatus: string
  addNewNumber: FormGroup;
  selectedMacId: string;
  selectedAccessoryId: string;
  availableAccessory: Map<string, ThingAccessories> = new Map<string, ThingAccessories>();
  availableStatus: Map<string, ThingStatus> = new Map<string, ThingStatus>();
  availableControls: Map<string, ThingControl> = new Map<string, ThingControl>();
  availableUsers: Map<string, string> = new Map<string, string>();
  availableAdmins: Map<string, string> = new Map<string, string>();
  subscription: Subscription;
  isSendingStatus: boolean;
  oldStatus: any;
  selectedThing: any;
  serialNumber: string;
  returnData: any;
  loading: boolean;
  fanSpeedChangeValue: number;
  timerSubscription: Subscription;
  updatedThing: any;
  panelOpenState: boolean = false;
  accessoryDetailArrayString = [];
  fanCurrentValue: number;
  isUser: boolean;
  usersArray = new Set();

  constructor(
    private dataStore: DataStore,
    private route: ActivatedRoute,
    private missionService: MissionService,
    private dialog: MatDialog,
    private router: Router,
    private httpService: HTTPCallsService,
    private formBuilder: FormBuilder,
    private dbService: NgxIndexedDBService,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {

    this.loading = true;
    this.isUser = false;
    this.selectedMacId = "thing/" + this.route.snapshot.paramMap.get("id");
    this.selectedAccessoryId = this.route.snapshot.paramMap.get("accessoryId");
    this.refreshData();
    this.prepareThingData()
  }
  refreshData() {
    this.prepareThingData()
    this.subscribeToSelectedMacIdData();
  }
  subscribeToSelectedMacIdData() {
    this.timerSubscription = Observable.timer(1000)
      .first()
      .subscribe(() => this.refreshData());
  }

  private prepareThingData() {
    this.dbService.getByKey("Things", this.selectedMacId).then(selectedData => {

      if (selectedData) {
        this.selectedThing = selectedData['thing'];


        if (this.selectedThing.thingType === "laptop") {
          this.serialNumber = this.selectedThing.macId.split("/")[2].replace(/:/gi, "");
        } else {
          this.serialNumber = this.selectedThing.macId.split("-")[1].replace(/:/gi, "");
        }
        this.currentUser = this.authService.currentUserValue;
        this.selectedThing.userAccess.forEach(element => {
          element.userList.forEach(elementValue => {
            this.usersArray.add(elementValue)
          });

        });
        if (this.usersArray.has(this.currentUser.phoneNumber)) {
          this.isUser = true
        }
        else {
          this.isUser = false
        }

        this.selectedThing.accessories.forEach(accessory => {
          var buildNumberObject = {
            buildNumber: this.selectedThing.buildNumber
          };
          var selectedAccessory = Object.assign(accessory, buildNumberObject);
          this.availableAccessory.set(this.selectedThing.macId + "/" + accessory.accessoryIdentifier, selectedAccessory);
          if (accessory.statusList.length > 0) {
            accessory.statusList.forEach(status => {
              this.availableStatus.set(this.selectedThing.macId + "/" + accessory.accessoryIdentifier + "/" + status.statusId, status);
            });
          }
          if (accessory.thingControl.length > 0) {
            accessory.thingControl.forEach(control => {
              this.availableControls.set(this.selectedThing.macId + "/" + accessory.accessoryIdentifier + "/" + control.controlIdentifier, control);
            });
          }
        });
        this.selectedThing.admins.forEach(phoneNumber => {
          this.httpService.getProfileIcon(phoneNumber).subscribe((data) => {
            this.availableUsers.set(phoneNumber, data);
          }, (error) => {
            console.log('Error ', error);
          });
        });
        this.selectedThing.userAccess.forEach(userAccessElement => {
          userAccessElement.userList.forEach(userListNumber => {
            this.httpService.getProfileIcon(userListNumber).subscribe((data) => {
              this.availableUsers.set(userListNumber, data);
            }, (error) => {
              console.log('Error ', error);
            });
          });
        });
        this.loading = false;
      }
    });
  }

  getProfilePicture(phoneNumber) {
    return this.availableUsers.get(phoneNumber);
  }

  getMaxValue(states): any {
    var max;
    states.forEach(element => {
      for (let [key, value] of element) {
        if (key == "Max") {
          max = value[0];
        }
      }
    });
    return max;
  }

  getMinValue(states): any {
    var min;
    states.forEach(element => {
      for (let [key, value] of element) {
        if (key == "Min") {
          min = value[0];
        }
      }
    });

    return min;
  }

  getSteps(states): any {
    var steps;
    states.forEach(element => {
      for (let [key, value] of element) {
        if (key == "steps") {
          steps = value[0];
        }
      }
    });

    return steps;
  }

  getCurrentValue(states): any {
    var currentValue;
    states.forEach(element => {
      for (let [key, value] of element) {
        if (key == "speed") {
          currentValue = value;
        }
      }
    });

    return currentValue;
  }



  private updateSelectedAccessory(newAccessoryId: string) {
    this.selectedAccessoryId = newAccessoryId;
    this.prepareThingData();
  }

  private controlThing(controlKey: string, currentState: string) {
    let control: ThingControl = this.availableControls.get(controlKey);
    var controlChannel = controlKey.split("/");
    var controlTopic =
      controlChannel[0] +
      "/" +
      controlChannel[1] +
      "/" +
      controlChannel[2] +
      "/" +
      control.topic;
    var message = {};
    this.isSendingStatus = true;
    this.oldStatus = currentState;
    if (currentState == "OFF") {
      message["power"] = { power: ["ON"] };
    } else if (currentState == "ON") {
      message["power"] = { power: ["OFF"] };
    }
  }
  editThing(macId) {
    this.router.navigate(["/dashboard/edit/", macId]);
  }
  onInputChange(event: MatSliderChange, accessory) {
    this.fanSpeedChangeValue = event.value;
    if (this.fanSpeedChangeValue) {
      var payLoad;
      accessory.statusList.forEach(element => {
        if (element.statusId === "speed") {
          if (accessory.buildNumber < 6) {
            payLoad = {
              speed: {
                currentSpeed: this.fanSpeedChangeValue
              }
            };
          } else if (accessory.buildNumber >= 6) {
            payLoad = {
              speed: this.fanSpeedChangeValue
            };
          }
        }
      });
      var topic;
      accessory.thingControl.forEach(controlElement => {
        if (controlElement.controlIdentifier == "speed") {
          topic =
            accessory.macID +
            "/" +
            accessory.accessoryIdentifier +
            "/" +
            controlElement.topic;
        }
      });

      let currentUser = JSON.parse(localStorage.getItem("currentUser"));

      var phoneNumber = currentUser["phoneNumber"];
      this.httpService
        .mqttPublish(topic, payLoad, phoneNumber)
        .subscribe(data => console.log(data));
    }
  }

  getCurtainState(state) {
    for (var [key, value] of state) {
      var currentState = key;
    }
    return currentState;
  }

  curtainActionCall(stateValue, accessory) {
    var payLoad;
    for (let [key, value] of stateValue) {
      var currentStatus = key.toLowerCase();
    }
    if (currentStatus === "close") {
      payLoad = {
        close: "CLOSE"
      };
    } else if (currentStatus === "open") {
      payLoad = { open: "OPEN" };
    } else if (currentStatus === "stop") {
      payLoad = { stop: "STOP" };
    }
    var topic =
      accessory.macId +
      "/" +
      accessory.accessoryIdentifier +
      "/" +
      accessory.topic;
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));

    var phoneNumber = currentUser["phoneNumber"];
    this.httpService
      .mqttPublish(topic, payLoad, phoneNumber)
      .subscribe(data => {
        console.log(data);
        if (data) {
        }
      });
  }

  actionCall(accessory) {
    var payLoad;
    accessory.statusList.forEach(element => {
      if (element.statusId === "power") {
        if (accessory.buildNumber < 6) {
          var status;
          var statusCheck = accessory.statusList[0].currentState[0];
          for (var [key, value] of statusCheck) {
            status = value;
          }
          if (status.toLowerCase() === "on") {
            payLoad = {
              power: {
                power: ["OFF"]
              }
            };
          } else if (status.toLowerCase() === "off") {
            payLoad = {
              power: {
                power: ["ON"]
              }
            };
          }
        } else if (accessory.buildNumber >= 6) {
          var status;
          var statusCheck = accessory.statusList[0].currentState[0];
          for (var [key, value] of statusCheck) {
            status = value;
          }
          if (status.toLowerCase() === "on") {
            payLoad = {
              power: "OFF"
            };
          } else if (status.toLowerCase() === "off") {
            payLoad = {
              power: "ON"
            };
          }
        }
      } else if (element.statusId === "curtain") {
        var statusCheck = accessory.statusList[0].currentState[0];
        for (var [key, value] of statusCheck) {
          var currentStatus = key.toLowerCase();
        }
        if (currentStatus === "close") {
          payLoad = {
            open: "OPEN"
          };
        } else {
          payLoad = {
            close: "CLOSE"
          };
        }
      }
    });


    var topic =
      accessory.macID +
      "/" +
      accessory.accessoryIdentifier +
      "/" +
      accessory.thingControl[0].topic;
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));

    var phoneNumber = currentUser["phoneNumber"];

    this.httpService
      .mqttPublish(topic, payLoad, phoneNumber)
      .subscribe(data => {
        console.log(data);
        if (data) {
        }
      });

  }
  openDialogforUser(groupName): void {
    console.log("group Name", groupName)
    const dialogRef = this.dialog.open(AddNumberDialogComponent, {
      width: "250px",
      data: { name: this.adminPhoneNumber }
    });

    dialogRef.afterClosed().subscribe(phoneNumber => {
      if (phoneNumber && groupName) {
        this.addUser(phoneNumber, groupName)
      }
    });
  }
  addUser(userphoneNumber, group) {
    var userAccessArray = []
    var userList = []
    console.log(this.selectedThing.userAccess)
    this.selectedThing.userAccess.forEach(elementGroup => {
      if (elementGroup.groupName == group) {
        userList = elementGroup.userList
        userList.push(userphoneNumber)
        var UpdatedGroup = {
          name: elementGroup.groupName,
          status: elementGroup.statusAccess,
          controls: elementGroup.controlAccess,
          userList: userList
        }
        userAccessArray.push(UpdatedGroup)
      }
      else {
        userAccessArray.push(elementGroup)
      }
    });
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    var phoneNumber = currentUser["phoneNumber"];
    var accessoriesDetails = this.selectedThing.accessories;
    accessoriesDetails.forEach(accessory => {
      var accessoryKey = accessory.accessoryIdentifier;
      var accessoryValue = {
        name: accessory.thingName,
        subLocation: {
          roomName: accessory.roomName
        },
        accessoryType: accessory.accessoryType,
        linkingDetails: {
          addLinkMacId: "",
          removeLinkMacId: ""
        }
      };
      this.accessoryDetailArrayString.push({
        [accessoryKey]: accessoryValue
      });
    });
    var accessoryArrayToObjects = {};
    for (var i = 0; i < this.accessoryDetailArrayString.length; i++) {
      accessoryArrayToObjects[i] = this.accessoryDetailArrayString[i];
    }
    let accessoryDetailObject = {};
    for (let res in accessoryArrayToObjects) {
      CombineObjects(accessoryArrayToObjects[res], accessoryDetailObject);
    }
    function CombineObjects(obj, variable) {
      for (let key of Object.keys(obj)) {
        if (!variable[key]) variable[key] = {};

        for (let innerKey of Object.keys(obj[key]))
          variable[key][innerKey] = obj[key][innerKey];
      }
    }

    Object.assign(
      accessoryDetailObject,
      { initialModel: this.selectedThing.initialModel },
      { initialVersion: this.selectedThing.initialVersion }
    );
    this.updatedThing = {
      admin: this.selectedThing.admins,
      _id: this.selectedThing.serverId,
      type: "thing",
      action: "update",
      macId: this.selectedThing.macId,
      thing: {
        manufacturerDetails: this.selectedThing.manufacturerDetails,
        location: {
          placeId: "",
          placeType: this.selectedThing.thingsLocation.placeType,
          placeName: this.selectedThing.thingsLocation.placeName,
          latitude: this.selectedThing.thingsLocation.latitude,
          longitude: this.selectedThing.thingsLocation.longitude,
          canEditLocation: this.selectedThing.thingsLocation.canEditLocation
        },
        canChangeThingType: this.selectedThing.canChangeThingType,
        isLinkableThing: this.selectedThing.isLinkableThing,
        model: this.selectedThing.model,
        version: this.selectedThing.version,
        thingType: this.selectedThing.thingType,
        buildNumber: this.selectedThing.buildNumber,
        updatedBy: phoneNumber,
        groupBy: this.selectedThing.groupBy,
        accessoriesDetails: accessoryDetailObject,
        userAccess: userAccessArray,
        roomName: this.selectedThing.roomName
      },
      timeStamp: Date.now(),
      __v: 0
    };
    var payLoad = this.updatedThing;
    var currentUserData = JSON.parse(localStorage.getItem("currentUser"));

    var phoneNumber = currentUserData["phoneNumber"];
    var topic = phoneNumber + "/out";
    this.httpService
      .mqttPublish(topic, payLoad, phoneNumber)
      .subscribe(data => console.log(data));
  }

  openDialogforAdmin(): void {
    const dialogRef = this.dialog.open(AddNumberDialogComponent, {
      width: "250px",
      data: { name: this.adminPhoneNumber }
    });

    dialogRef.afterClosed().subscribe(phoneNumber => {
      console.log(phoneNumber);
      if (phoneNumber != null || undefined) {
        console.log("RESULT", phoneNumber)
        this.addUserAdmin(phoneNumber)
      }
    });
  }

  addUserAdmin(phoneNumber) {

    var newAdminList = this.selectedThing.admins;
    if (phoneNumber) {
      newAdminList.push(phoneNumber);
    }
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    var accessoryDetailsMap = new Map<any, any>();
    var phoneNumber = currentUser["phoneNumber"];
    var accessoriesDetails = this.selectedThing.accessories;
    accessoriesDetails.forEach(accessory => {
      var accessoryKey = accessory.accessoryIdentifier;
      var accessoryValue = {
        name: accessory.thingName,
        subLocation: {
          roomName: accessory.roomName
        },
        accessoryType: accessory.accessoryType,
        linkingDetails: {
          addLinkMacId: "",
          removeLinkMacId: ""
        }
      };

      this.accessoryDetailArrayString.push({
        [accessoryKey]: accessoryValue
      });
    });
    var accessoryArrayToObjects = {};
    for (var i = 0; i < this.accessoryDetailArrayString.length; i++) {
      accessoryArrayToObjects[i] = this.accessoryDetailArrayString[i];
    }

    let accessoryDetailObject = {};
    for (let res in accessoryArrayToObjects) {
      CombineObjects(accessoryArrayToObjects[res], accessoryDetailObject);
    }

    function CombineObjects(obj, variable) {
      for (let key of Object.keys(obj)) {
        if (!variable[key]) variable[key] = {};

        for (let innerKey of Object.keys(obj[key]))
          variable[key][innerKey] = obj[key][innerKey];
      }
    }

    Object.assign(
      accessoryDetailObject,
      { initialModel: this.selectedThing.initialModel },
      { initialVersion: this.selectedThing.initialVersion }
    );

    var userAccessObject = [];
    var userAccessArray;
    var status = [];
    var control = [];
    var selectedThingUserAccess = this.selectedThing.userAccess;

    selectedThingUserAccess.forEach(element => {
      var name = element.groupName;
      var userList = element.userList;
      element.statusAccess.forEach(innerStatuselement => {
        status.push(innerStatuselement.statusAccessList);
      });
      element.controlAccess.forEach(innerControlelement => {
        control.push(innerControlelement.controlAccessList);
      });
      (userAccessArray = {
        name: name,

        status: status,
        control: control,
        userList: userList
      }),
        userAccessObject.push(userAccessArray);
    });

    this.updatedThing = {
      admin: this.selectedThing.admins,
      _id: this.selectedThing.serverId,
      type: "thing",
      action: "update",
      macId: this.selectedThing.macId,
      thing: {
        manufacturerDetails: this.selectedThing.manufacturerDetails,
        location: {
          placeId: "",
          placeType: this.selectedThing.thingsLocation.placeType,
          placeName: this.selectedThing.thingsLocation.placeName,
          latitude: this.selectedThing.thingsLocation.latitude,
          longitude: this.selectedThing.thingsLocation.longitude,
          canEditLocation: this.selectedThing.thingsLocation.canEditLocation
        },
        canChangeThingType: this.selectedThing.canChangeThingType,
        isLinkableThing: this.selectedThing.isLinkableThing,
        model: this.selectedThing.model,
        version: this.selectedThing.version,
        thingType: this.selectedThing.thingType,
        buildNumber: this.selectedThing.buildNumber,
        updatedBy: phoneNumber,
        groupBy: this.selectedThing.groupBy,
        accessoriesDetails: accessoryDetailObject,
        userAccess: userAccessObject,
        roomName: this.selectedThing.roomName
      },
      timeStamp: Date.now(),
      __v: 0
    };
    var payLoad = this.updatedThing;
    var currentUserData = JSON.parse(localStorage.getItem("currentUser"));

    var phoneNumber = currentUserData["phoneNumber"];
    var topic = phoneNumber + "/out";
    console.log("thing", this.updatedThing)


    this.httpService
      .mqttPublish(topic, payLoad, phoneNumber)
      .subscribe(data => console.log(data));
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(MsaterControlComponent, {
      width: "350px",
      data: { name: this.masterStatus }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result != null || undefined) {

        console.log("result", result)
        this.masterStatus = result
        this.masterOnOff()
      }
    });
  }

  masterOnOff() {
    var currentUserData = JSON.parse(localStorage.getItem("currentUser"));
    var payLoad;

    var phoneNumber = currentUserData["phoneNumber"];
    if (this.selectedThing.buildNumber > 2) {
      var topic = this.selectedMacId + "/masterControl";
      var masterOnOffValueSet = new Set<any>();
      if (this.masterStatus == "OFF") {
        payLoad = { power: "OFF" };
      } else {
        payLoad = { power: "ON" };
      }

      this.httpService
        .mqttPublish(topic, payLoad, phoneNumber)
        .subscribe(data => console.log(data));
    } else {

      var payLoad: any
      console.log(this.masterStatus)
      if (this.masterStatus === 'OFF') {
        payLoad = { power: { power: ["OFF"] } };
      } else if (this.masterStatus === 'ON') {
        payLoad = { power: { power: ["ON"] } };
      }

      for (let [key, value] of this.availableStatus) {

        var topic = value.thingMacId + '/' + value.accessoryIdentifier + '/' + 'powerControl'

        this.httpService
          .mqttPublish(topic, payLoad, phoneNumber)
          .subscribe(data => {
            console.log(data);
          });
      }
    }
  }

  ngOnDestroy() {
    this.timerSubscription.unsubscribe();
  }
}
